import { useContext, VFC } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// Utils
import { AppContext } from "config/appProvider";
import { DASHBOARD, IMPORT, CUSTOM_IMPORT, WEIGHT_IMPORT } from "constants/Routes";
import { BU_TYPES } from "trading/constants";
import { useHasFeature } from "hooks";
// Pages
import { Import, ImportCustom, ImportExternal } from "pages";

const IMPORT_PATHS = {
  Root: IMPORT,
  Custom: `${IMPORT}${CUSTOM_IMPORT}`,
  External: `${IMPORT}${WEIGHT_IMPORT}`,
};

export const PATHS = Object.keys(IMPORT_PATHS).map((key) => IMPORT_PATHS[key]);

export const ImportsRoutes: VFC = () => {
  const {
    mainAppState: { selectedBUType },
  } = useContext(AppContext);

  const isShowAnimalsForBuyer: boolean = useHasFeature("SHOW_ANIMALS_FOR_BUYER");

  const isFarmer: boolean = selectedBUType !== BU_TYPES.processor;

  const isImportsEnable: boolean = isFarmer || isShowAnimalsForBuyer;

  const importsRoutes = [
    <Route exact path={IMPORT_PATHS.Root} key={IMPORT_PATHS.Root} component={Import} />,
    <Route exact path={IMPORT_PATHS.External} key={IMPORT_PATHS.External} component={ImportExternal} />,
    <Route exact path={IMPORT_PATHS.Custom} key={IMPORT_PATHS.Custom} component={ImportCustom} />,
  ];

  return (
    <Route exact path={PATHS}>
      <Switch>
        {isImportsEnable && importsRoutes}
        <Redirect to={DASHBOARD} />
      </Switch>
    </Route>
  );
};
